import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_file_field = _resolveComponent("g-file-field");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: _ctx.$tc(`client.Commerce.${_ctx.cartType === 'L' ? 'OrderLists' : 'Carts'}.${'UploadFiles'}.Titel`)
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: _ctx.$tc('shared.Text.Close'),
                onClick: _ctx.currentWindow.close,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["text", "onClick"])
        ]),
        default: _withCtx(() => [
            _createVNode(_component_g_file_field, {
                "upload-url": '/frontend/v1/commerce/checkout/' + _ctx.cartID + '/lines/' + _ctx.lineID + '/files',
                "delete-url": '/frontend/v1/commerce/checkout/' + _ctx.cartID + '/lines/' + _ctx.lineID + '/files/{fileID}',
                "open-url": '/frontend/v1/commerce/checkout/' + _ctx.cartID + '/lines/' + _ctx.lineID + '/files/{fileID}',
                "empty-text": 'Keine Dokumente bisher hochgeladen...',
                accept: '*',
                "max-file-size": 30 * 1024 * 1024,
                multiple: true,
                "data-member": 'files',
                "data-mode": 'model',
                "data-object": _ctx.line
            }, null, 8, ["upload-url", "delete-url", "open-url", "empty-text", "data-object"])
        ]),
        _: 1
    }, 8, ["title"]));
}
